import React, { useState } from 'react';
import { 
  Button, 
  Typography, 
  Card, 
  List, 
  Tag,
  Space,
  Row,
  Col,
  Radio,
  DatePicker,
  Input,
  Empty,
  Drawer,
  Tabs,
  Modal,
  Descriptions,
  message,
  Popover,
  Popconfirm,
  Tooltip,
  Divider,
  Form,
  Select,
  Switch,
  Dropdown,
  Menu,
  Checkbox,
  InputNumber
} from 'antd';
import { 
  LeftOutlined,
  CalendarOutlined,
  SearchOutlined,
  FilterOutlined,
  DownloadOutlined,
  RightOutlined,
  MoreOutlined,
  ExclamationCircleOutlined,
  SplitCellsOutlined,
  DollarOutlined,
  SettingOutlined,
  TransactionOutlined,
  PlusOutlined,
  DownOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import type { RadioChangeEvent } from 'antd';
import locale from 'antd/es/date-picker/locale/zh_CN';

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;
const { Search } = Input;

// 模拟账户概览数据
const accountOverview = {
  currentBalance: 1258.00,
  totalIncome: 3580.00,
  pendingSettlement: 320.00
};

// 模拟交易数据，更丰富的数据模型
const transactions = [
  {
    id: 't008',
    type: 'commission', // 订单分佣
    orderNo: 'ORD20230522008',
    customer: '客户D',
    amount: 450,
    date: '2023-05-22',
    time: '16:35:12',
    status: 'settled', // 已结算 - 符合分账条件
    source: '客户订单',
    paymentId: 'PAY78902567',
    description: '客户D的豪华套房订单分佣',
    details: {
      orderItems: ['豪华套房1晚', '早餐2份'],
      orderTotal: 4500,
      commissionRate: '10%',
      commissionAmount: 450
    },
    splitStatus: '未分账', // 未分账 - 符合分账条件
    splitInfo: null
  },
  {
    id: 't001',
    type: 'commission', // 订单分佣
    orderNo: 'ORD20230520001',
    customer: '客户C',
    amount: 320,
    date: '2023-05-20',
    time: '14:30:25',
    status: 'pending', // 待结算
    source: '客户订单',
    paymentId: 'PAY78902396',
    description: '客户C的酒店预订订单分佣',
    details: {
      orderItems: ['标准房2晚'],
      orderTotal: 3200,
      commissionRate: '10%',
      commissionAmount: 320
    },
    splitStatus: '未分账',
    splitInfo: null
  },
  {
    id: 't002',
    type: 'commission', // 订单分佣
    orderNo: 'ORD20230518002',
    customer: '客户B',
    amount: 258,
    date: '2023-05-18',
    time: '09:15:03',
    status: 'settled', // 已结算
    source: '客户订单',
    paymentId: 'PAY78902347',
    description: '客户B的酒店预订订单分佣',
    details: {
      orderItems: ['豪华房1晚'],
      orderTotal: 2580,
      commissionRate: '10%',
      commissionAmount: 258
    },
    splitStatus: '已分账',
    splitInfo: {
      splitWith: '王五',
      splitRatio: 0.3,
      splitAmount: 77.4,
      ownAmount: 180.6,
      splitTime: '2023-05-19 10:23:45',
      splitReason: '协助服务'
    }
  },
  {
    id: 't003',
    type: 'transfer', // 转账收入
    orderNo: 'TRF20230516003',
    customer: '系统',
    amount: 180,
    date: '2023-05-16',
    time: '16:45:32',
    status: 'settled', // 已结算
    source: '系统转账',
    paymentId: 'TRF78934223',
    description: '业绩奖励转账',
    details: {
      transferType: '系统转账',
      transferReason: '团队业绩奖励',
      transferAmount: 180
    },
    splitStatus: '不可分账',
    splitInfo: null
  },
  {
    id: 't004',
    type: 'bonus', // 系统赠送
    orderNo: 'BNS20230510004',
    customer: '系统',
    amount: 100,
    date: '2023-05-10',
    time: '12:00:00',
    status: 'settled', // 已结算
    source: '系统赠送',
    paymentId: 'BNS78923496',
    description: '新人奖励',
    details: {
      bonusType: '系统奖励',
      bonusReason: '新人注册奖励',
      bonusAmount: 100
    },
    splitStatus: '未分账',
    splitInfo: null
  },
  {
    id: 't005',
    type: 'withdraw', // 提现
    orderNo: 'WTD20230505005',
    customer: '自己',
    amount: -500,
    date: '2023-05-05',
    time: '10:20:15',
    status: 'completed', // 已完成
    source: '提现到银行卡',
    paymentId: 'WTD78998766',
    description: '提现到招商银行(尾号3322)',
    details: {
      withdrawMethod: '银行卡',
      accountInfo: '招商银行(尾号3322)',
      withdrawAmount: 500,
      fee: 0,
      actualAmount: 500
    }
  },
  {
    id: 't006',
    type: 'withdraw', // 提现
    orderNo: 'WTD20230425006',
    customer: '自己',
    amount: -300,
    date: '2023-04-25',
    time: '14:30:00',
    status: 'processing', // 处理中
    source: '提现到微信钱包',
    paymentId: 'WTD78912345',
    description: '提现到微信钱包',
    details: {
      withdrawMethod: '微信钱包',
      accountInfo: '微信账号',
      withdrawAmount: 300,
      fee: 0,
      actualAmount: 300
    }
  },
  {
    id: 't007',
    type: 'split_income', // 分账收入
    orderNo: 'SPL20230519007',
    customer: '李四',
    amount: 120,
    date: '2023-05-19',
    time: '10:23:45',
    status: 'settled', // 已结算
    source: '分账收入',
    paymentId: 'SPL78923456',
    description: '来自李四的订单分账收入',
    details: {
      originalOrderNo: 'ORD20230517099',
      originalAmount: 400,
      splitRatio: '30%',
      splitAmount: 120,
      splitReason: '协助客户服务'
    },
    splitStatus: '分账收入',
    splitInfo: null
  }
];

// 模拟员工数据，用于分账选择
const employees = [
  { id: '1', name: '李四', position: '餐饮顾问' },
  { id: '2', name: '王五', position: '管家' },
  { id: '3', name: '张三', position: '前台' }
];

// 模拟分账规则数据
const splitRules = [
  {
    id: '1',
    name: '管家介绍规则',
    description: '管家引荐客户，按照成交佣金的30%分成',
    ratio: 0.3,
    isActive: true
  },
  {
    id: '2',
    name: '新客户转介绍',
    description: '客人介绍新客户，给予原客户10%的分成',
    ratio: 0.1,
    isActive: true
  },
  {
    id: '3',
    name: '团队合作分成',
    description: '团队合作服务时按照不同角色比例分配',
    ratio: 0.5,
    isActive: false
  }
];

const CommissionDetailPage: React.FC = () => {
  const navigate = useNavigate();
  const [typeFilter, setTypeFilter] = useState<string>('all');
  const [dateRange, setDateRange] = useState<[string, string] | null>(null);
  const [searchText, setSearchText] = useState<string>('');
  const [datePickerVisible, setDatePickerVisible] = useState<boolean>(false);
  const [detailDrawerVisible, setDetailDrawerVisible] = useState<boolean>(false);
  const [currentTransaction, setCurrentTransaction] = useState<any>(null);
  const [splitModalVisible, setSplitModalVisible] = useState<boolean>(false);
  const [splitForm] = Form.useForm();
  const [splitRuleModalVisible, setSplitRuleModalVisible] = useState<boolean>(false);
  const [splitRuleForm] = Form.useForm();
  const [splitRatio, setSplitRatio] = useState<number>(0);
  const [calculatedSplitAmount, setCalculatedSplitAmount] = useState<number>(0);
  
  // 新增筛选状态变量
  const [statusFilter, setStatusFilter] = useState<string[]>([]);
  const [splitStatusFilter, setSplitStatusFilter] = useState<string[]>([]);
  const [filterDrawerVisible, setFilterDrawerVisible] = useState<boolean>(false);
  const [incomeTypeFilter, setIncomeTypeFilter] = useState<string[]>([]);
  
  // 获取交易类型颜色和文本
  const getTransactionTypeInfo = (type: string) => {
    switch (type) {
      case 'commission':
        return { color: 'green', text: '订单分佣', icon: '🛒' };
      case 'transfer':
        return { color: 'blue', text: '转账收入', icon: '💸' };
      case 'bonus':
        return { color: 'orange', text: '系统赠送', icon: '🎁' };
      case 'withdraw':
        return { color: 'red', text: '提现', icon: '💰' };
      case 'split_income':
        return { color: 'purple', text: '分账收入', icon: '🔄' };
      default:
        return { color: 'default', text: '未知', icon: '❓' };
    }
  };
  
  // 获取交易状态颜色和文本
  const getTransactionStatusInfo = (status: string) => {
    switch (status) {
      case 'pending':
        return { color: 'orange', text: '待结算' };
      case 'processing':
        return { color: 'blue', text: '处理中' };
      case 'settled':
        return { color: 'green', text: '已结算' };
      case 'completed':
        return { color: 'green', text: '已完成' };
      default:
        return { color: 'default', text: '未知' };
    }
  };

  // 筛选数据
  const filteredTransactions = transactions.filter(item => {
    // 类型筛选
    if (typeFilter === 'income' && item.amount < 0) {
      return false;
    }
    if (typeFilter === 'withdraw' && (item.amount > 0 || item.type !== 'withdraw')) {
      return false;
    }
    if (typeFilter === 'expense' && (item.amount > 0 || item.type === 'withdraw')) {
      return false;
    }
    
    // 账单类型筛选
    if (incomeTypeFilter.length > 0 && !incomeTypeFilter.includes(item.type)) {
      return false;
    }
    
    // 日期筛选
    if (dateRange && dateRange[0] && dateRange[1]) {
      const itemDate = new Date(item.date);
      const startDate = new Date(dateRange[0]);
      const endDate = new Date(dateRange[1]);
      if (itemDate < startDate || itemDate > endDate) {
        return false;
      }
    }
    
    // 状态筛选 - 新增
    if (statusFilter.length > 0 && !statusFilter.includes(item.status)) {
      return false;
    }
    
    // 分账状态筛选 - 新增
    if (splitStatusFilter.length > 0) {
      // 提现类型和分账收入类型没有分账状态，所以如果筛选了分账状态，这两种类型记录不显示
      if (item.type === 'withdraw' || item.type === 'split_income') {
        return false;
      }
      if (!item.splitStatus || !splitStatusFilter.includes(item.splitStatus)) {
        return false;
      }
    }
    
    // 搜索筛选
    if (searchText) {
      const searchLower = searchText.toLowerCase();
      if (item.type === 'withdraw') {
        // 提现类型的搜索
        return (
          (item.orderNo && item.orderNo.toLowerCase().includes(searchLower)) ||
          (item.source && item.source.toLowerCase().includes(searchLower)) ||
          (item.details?.accountInfo && item.details.accountInfo.toLowerCase().includes(searchLower)) ||
          (item.description && item.description.toLowerCase().includes(searchLower))
        );
      } else {
        // 其他类型的搜索
        return (
          (item.orderNo && item.orderNo.toLowerCase().includes(searchLower)) ||
          (item.source && item.source.toLowerCase().includes(searchLower)) ||
          (item.customer && item.customer.toLowerCase().includes(searchLower)) ||
          (item.description && item.description.toLowerCase().includes(searchLower))
        );
      }
    }
    
    return true;
  }).sort((a, b) => {
    // 默认按时间降序排序
    const dateA = new Date(`${a.date} ${a.time}`).getTime();
    const dateB = new Date(`${b.date} ${b.time}`).getTime();
    return dateB - dateA;
  });
  
  // 计算收入支出统计
  const totalIncome = transactions.filter(t => t.amount > 0).reduce((sum, t) => sum + t.amount, 0);
  const totalWithdraw = Math.abs(transactions.filter(t => t.amount < 0).reduce((sum, t) => sum + t.amount, 0));
  
  // 类型切换
  const handleTypeChange = (e: RadioChangeEvent) => {
    setTypeFilter(e.target.value);
  };
  
  // 日期范围切换
  const handleDateChange = (dates: any, dateStrings: [string, string]) => {
    setDateRange(dateStrings);
    setDatePickerVisible(false);
  };
  
  // 搜索处理
  const handleSearch = (value: string) => {
    setSearchText(value);
  };
  
  // 查看交易详情
  const handleViewDetail = (transaction: any) => {
    setCurrentTransaction(transaction);
    setDetailDrawerVisible(true);
  };
  
  // 导出对账单
  const handleExport = () => {
    Modal.confirm({
      title: '导出对账单',
      icon: <ExclamationCircleOutlined />,
      content: '确定要导出当前筛选条件下的对账单吗？',
      okText: '确认',
      cancelText: '取消',
      onOk() {
        message.success('对账单导出成功，请在下载中心查看');
      }
    });
  };
  
  // 处理分账操作
  const handleSplitCommission = (transaction: any) => {
    // 检查交易状态，只允许已结算或已完成状态的佣金进行分账
    if (transaction.type !== 'commission' || 
        transaction.splitStatus !== '未分账' ||
        (transaction.status !== 'settled' && transaction.status !== 'completed')) {
      message.warning('只有已结算或已完成状态的佣金才可以进行分账操作');
      return;
    }
    
    setCurrentTransaction(transaction);
    // 重置分账状态
    setSplitRatio(0);
    setCalculatedSplitAmount(0);
    splitForm.resetFields();
    // 确保将初始值设置为0
    splitForm.setFieldsValue({ 
      splitRatio: 0,
      splitWith: undefined,
      splitReason: undefined,
      remark: ''
    });
    setSplitModalVisible(true);
  };
  
  // 处理分账提交
  const handleSplitSubmit = () => {
    splitForm.validateFields().then(values => {
      // 实际应用中应该调用后端API处理分账
      if (!currentTransaction) {
        message.error('交易信息不存在');
        return;
      }
      
      const ratio = splitRatio || 0;
      const splitAmount = calculatedSplitAmount || 0;
      const remainAmount = currentTransaction.amount - splitAmount;
      const orderNo = currentTransaction.orderNo || '';
      const currentDate = new Date().toISOString().split('T')[0];
      const currentTime = new Date().toTimeString().split(' ')[0];
      
      // 创建一条新的分账支出记录（负数金额）
      const newSplitExpenseRecord = {
        id: `split-exp-${Date.now()}`,
        type: 'split_expense', // 分账支出
        orderNo: `SPLIT${Date.now().toString().slice(-6)}`,
        customer: values.splitWith,
        amount: -splitAmount, // 负数金额表示支出
        date: currentDate,
        time: currentTime,
        status: 'completed',
        source: '分账支出',
        paymentId: `SPL${Date.now().toString().slice(-8)}`,
        description: `将订单${orderNo}分账给${values.splitWith}`,
        details: {
          orderItems: [`订单${orderNo}的分账支出`],
          orderTotal: splitAmount,
          commissionRate: '100%',
          commissionAmount: splitAmount,
          splitOriginalOrder: orderNo,
          splitReason: values.splitReason || '',
          splitRemark: values.remark || ''
        },
        splitStatus: '已分账',
        splitInfo: {
          splitWith: values.splitWith,
          splitRatio: ratio,
          splitAmount: splitAmount,
          ownAmount: remainAmount,
          splitTime: `${currentDate} ${currentTime}`,
          splitReason: values.splitReason
        }
      };
      
      // 更新原交易记录的分账状态（在真实系统中应通过API更新）
      const updatedTransactions = transactions.map(t => {
        if (t.id === currentTransaction.id) {
          return {
            ...t,
            splitStatus: '已分账',
            splitInfo: {
              splitWith: values.splitWith,
              splitRatio: ratio,
              splitAmount: splitAmount,
              ownAmount: remainAmount,
              splitTime: `${currentDate} ${currentTime}`,
              splitReason: values.splitReason
            }
          };
        }
        return t;
      });
      
      // 添加新记录到交易列表头部
      // 注意：在实际应用中，这应该通过API请求完成，这里仅做模拟
      // 实际使用时不要直接修改transactions，而是通过后端API操作
      transactions.unshift(newSplitExpenseRecord as any);
      
      message.success(`已成功将订单${orderNo}分账给${values.splitWith}，分账金额${splitAmount.toFixed(2)}元，分账比例${(ratio * 100).toFixed(0)}%`);
      setSplitModalVisible(false);
      
      // 关闭详情抽屉，以便用户可以看到新添加的记录
      setDetailDrawerVisible(false);
    }).catch(err => {
      console.error('表单验证失败:', err);
      message.error('请完成所有必填项');
    });
  };
  
  // 处理分账规则设置
  const handleSplitRuleSubmit = () => {
    splitRuleForm.validateFields().then(values => {
      // 实际应用中应该调用后端API处理分账规则更新
      message.success('分账规则已更新');
      setSplitRuleModalVisible(false);
    });
  };
  
  // 渲染交易详情抽屉
  const renderDetailDrawer = () => {
    if (!currentTransaction) return null;
    
    const typeInfo = getTransactionTypeInfo(currentTransaction.type);
    const statusInfo = getTransactionStatusInfo(currentTransaction.status);
    
    // 定义是否可以分账的条件
    const canSplit = currentTransaction.type === 'commission' && 
                      currentTransaction.splitStatus === '未分账' &&
                      (currentTransaction.status === 'settled' || 
                       currentTransaction.status === 'completed');
    
    // 定义是否显示分账状态 - 提现类型和分账收入类型不显示
    const showSplitStatus = currentTransaction.type !== 'withdraw' && 
                           currentTransaction.type !== 'split_income' && 
                           currentTransaction.splitStatus;
    
    return (
      <Drawer
        title="交易详情"
        placement="right"
        width={320}
        onClose={() => setDetailDrawerVisible(false)}
        open={detailDrawerVisible}
      >
        <div style={{ marginBottom: 24 }}>
          <Tag icon={typeInfo.icon} color={typeInfo.color}>{typeInfo.text}</Tag>
          <Tag color={statusInfo.color}>{statusInfo.text}</Tag>
          {showSplitStatus && (
            <Tag 
              color={currentTransaction.splitStatus === '已分账' ? 'purple' : 
                     currentTransaction.splitStatus === '分账收入' ? 'geekblue' : 
                     currentTransaction.splitStatus === '不可分账' ? 'default' : 'gold'}
            >
              {currentTransaction.splitStatus}
            </Tag>
          )}
        </div>
        
        <Descriptions title="基本信息" column={1} bordered size="small">
          {currentTransaction.type === 'withdraw' ? (
            <Descriptions.Item label="提现单号">{currentTransaction.orderNo}</Descriptions.Item>
          ) : (
            <Descriptions.Item label="订单编号">{currentTransaction.orderNo}</Descriptions.Item>
          )}
          <Descriptions.Item label="交易金额">
            <span style={{ 
              color: currentTransaction.amount >= 0 ? '#52c41a' : '#f5222d',
              fontWeight: 'bold'
            }}>
              {currentTransaction.amount >= 0 ? '+' : ''}{currentTransaction.amount.toFixed(2)}元
            </span>
          </Descriptions.Item>
          <Descriptions.Item label="交易时间">{currentTransaction.date} {currentTransaction.time}</Descriptions.Item>
          <Descriptions.Item label="客户/来源">{currentTransaction.customer}</Descriptions.Item>
          <Descriptions.Item label="交易描述">{currentTransaction.description}</Descriptions.Item>
          <Descriptions.Item label="支付单号">{currentTransaction.paymentId}</Descriptions.Item>
        </Descriptions>
        
        {/* 添加分账信息展示 */}
        {currentTransaction.splitInfo && (
          <>
            <Divider />
            <Descriptions title="分账信息" column={1} bordered size="small">
              <Descriptions.Item label="分账对象">{currentTransaction.splitInfo.splitWith}</Descriptions.Item>
              <Descriptions.Item label="分账比例">{(currentTransaction.splitInfo.splitRatio * 100).toFixed(0)}%</Descriptions.Item>
              <Descriptions.Item label="分账金额">{currentTransaction.splitInfo.splitAmount.toFixed(2)}元</Descriptions.Item>
              <Descriptions.Item label="实际到账">{currentTransaction.splitInfo.ownAmount.toFixed(2)}元</Descriptions.Item>
              <Descriptions.Item label="分账时间">{currentTransaction.splitInfo.splitTime}</Descriptions.Item>
              <Descriptions.Item label="分账原因">{currentTransaction.splitInfo.splitReason}</Descriptions.Item>
            </Descriptions>
          </>
        )}
        
        {/* 添加分账收入信息展示 */}
        {currentTransaction.type === 'split_income' && currentTransaction.details && (
          <>
            <Divider />
            <Descriptions title="分账收入详情" column={1} bordered size="small">
              <Descriptions.Item label="原订单编号">{currentTransaction.details.originalOrderNo}</Descriptions.Item>
              <Descriptions.Item label="原订单金额">{currentTransaction.details.originalAmount.toFixed(2)}元</Descriptions.Item>
              <Descriptions.Item label="分账比例">{currentTransaction.details.splitRatio}</Descriptions.Item>
              <Descriptions.Item label="分账原因">{currentTransaction.details.splitReason}</Descriptions.Item>
            </Descriptions>
          </>
        )}
        
        {/* 根据具体类型显示不同的订单详情 */}
        {currentTransaction.details && currentTransaction.type === 'commission' && (
          <>
            <Divider />
            <Descriptions title="订单详情" column={1} bordered size="small">
              <Descriptions.Item label="订单项目">{currentTransaction.details.orderItems.join(', ')}</Descriptions.Item>
              <Descriptions.Item label="订单总额">{currentTransaction.details.orderTotal.toFixed(2)}元</Descriptions.Item>
              <Descriptions.Item label="佣金比例">{currentTransaction.details.commissionRate}</Descriptions.Item>
            </Descriptions>
          </>
        )}
        
        {/* 更新分账操作按钮显示条件 */}
        {canSplit && (
          <div style={{ marginTop: 24 }}>
            <Button 
              type="primary" 
              icon={<SplitCellsOutlined />} 
              block
              onClick={() => handleSplitCommission(currentTransaction)}
              style={{ backgroundColor: '#529C8A', borderColor: '#529C8A' }}
            >
              分账操作
            </Button>
          </div>
        )}
        
        {/* 如果不能分账但是commission类型，显示原因 */}
        {currentTransaction.type === 'commission' && 
         currentTransaction.splitStatus === '未分账' && 
         currentTransaction.status !== 'settled' && 
         currentTransaction.status !== 'completed' && (
          <div style={{ marginTop: 16, padding: '12px', backgroundColor: '#fff7e6', borderRadius: 4 }}>
            <Text type="warning">
              提示: 佣金在结算完成后才能进行分账操作
            </Text>
          </div>
        )}
      </Drawer>
    );
  };

  // 渲染筛选面板
  const renderFilterDrawer = () => {
    // 获取所有可能的交易状态值
    const allStatuses = Array.from(new Set(transactions.map(t => t.status)));
    const statusOptions = allStatuses.map(status => {
      const statusInfo = getTransactionStatusInfo(status);
      return {
        label: statusInfo.text,
        value: status,
      };
    });
    
    // 获取所有可能的账单类型值
    const allIncomeTypes = Array.from(new Set(transactions.map(t => t.type)));
    const incomeTypeOptions = allIncomeTypes.map(type => {
      const typeInfo = getTransactionTypeInfo(type);
      return {
        label: (
          <span>
            <Tag color={typeInfo.color} style={{ marginRight: 8 }}>{typeInfo.text}</Tag>
          </span>
        ),
        value: type,
      };
    });
    
    // 获取所有可能的分账状态值（排除withdraw类型和分账收入类型）
    const allSplitStatuses = Array.from(
      new Set(
        transactions
          .filter(t => t.type !== 'withdraw' && t.type !== 'split_income')
          .map(t => t.splitStatus)
          .filter(Boolean)
      )
    );
    const splitStatusOptions = allSplitStatuses.map(splitStatus => {
      let color = 'default';
      switch(splitStatus) {
        case '已分账': color = 'purple'; break;
        case '未分账': color = 'gold'; break;
        case '不可分账': color = 'default'; break;
        default: color = 'default';
      }
      
      return {
        label: (
          <span>
            <Tag color={color} style={{ marginRight: 8 }}>{splitStatus}</Tag>
          </span>
        ),
        value: splitStatus,
      };
    });
    
    const handleClearFilters = () => {
      setStatusFilter([]);
      setSplitStatusFilter([]);
      setIncomeTypeFilter([]);
      setFilterDrawerVisible(false);
    };
    
    const handleApplyFilters = () => {
      setFilterDrawerVisible(false);
      message.success('筛选条件已应用');
    };
    
    return (
      <Drawer
        title="高级筛选"
        placement="right"
        width={300}
        onClose={() => setFilterDrawerVisible(false)}
        open={filterDrawerVisible}
        footer={
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button onClick={handleClearFilters}>清除筛选</Button>
            <Button 
              type="primary" 
              onClick={handleApplyFilters}
              style={{ backgroundColor: '#529C8A', borderColor: '#529C8A' }}
            >
              应用筛选
            </Button>
          </div>
        }
      >
        <div style={{ marginBottom: 24 }}>
          <Title level={5}>交易状态</Title>
          <Checkbox.Group
            options={statusOptions}
            value={statusFilter}
            onChange={(values) => setStatusFilter(values as string[])}
            style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
          />
        </div>
        
        <Divider />
        
        <div>
          <Title level={5}>账单类型</Title>
          <Checkbox.Group
            options={incomeTypeOptions}
            value={incomeTypeFilter}
            onChange={(values) => setIncomeTypeFilter(values as string[])}
            style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
          />
        </div>
        
        <Divider />
        
        <div>
          <Title level={5}>分账状态</Title>
          <Checkbox.Group
            value={splitStatusFilter}
            onChange={(values) => setSplitStatusFilter(values as string[])}
            style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
          >
            {splitStatusOptions.map(option => (
              <Checkbox key={option.value as string} value={option.value}>
                {option.label}
              </Checkbox>
            ))}
          </Checkbox.Group>
        </div>
      </Drawer>
    );
  };

  return (
    <div style={{ 
      maxWidth: 500, 
      margin: '0 auto', 
      background: '#f5f5f5', 
      minHeight: '100vh',
      paddingBottom: 24
    }}>
      {/* 顶部标题栏 */}
      <div style={{ 
        padding: '12px 16px', 
        background: '#fff', 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid #f0f0f0',
      }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Button 
            type="text" 
            icon={<LeftOutlined />} 
            onClick={() => navigate(-1)}
            style={{ marginRight: 8 }}
          />
          <div style={{ fontSize: 16, fontWeight: 'bold' }}>账户明细</div>
        </div>
        <Space>
          <Tooltip title="分账规则设置">
            <Button 
              type="text" 
              icon={<SettingOutlined />} 
              onClick={() => setSplitRuleModalVisible(true)}
            />
          </Tooltip>
          <Tooltip title="导出明细">
            <Button 
              type="text" 
              icon={<DownloadOutlined />} 
              onClick={handleExport}
            />
          </Tooltip>
        </Space>
      </div>
      
      {/* 账户概览 */}
      <Card style={{ margin: '12px', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
        <div style={{ padding: '8px 0 16px' }}>
          <div style={{ textAlign: 'center', marginBottom: 16 }}>
            <Text style={{ fontSize: 14, color: '#666' }}>当前余额(元)</Text>
            <div style={{ fontSize: 28, fontWeight: 'bold', color: '#529C8A', margin: '4px 0' }}>
              ¥{accountOverview.currentBalance.toFixed(2)}
            </div>
          </div>
          
          <Row gutter={16}>
            <Col span={12}>
              <div style={{ textAlign: 'center' }}>
                <Text style={{ fontSize: 13, color: '#666' }}>累计收入(元)</Text>
                <div style={{ fontSize: 18, fontWeight: 'bold', color: '#52c41a', marginTop: 4 }}>
                  ¥{accountOverview.totalIncome.toFixed(2)}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div style={{ textAlign: 'center' }}>
                <Text style={{ fontSize: 13, color: '#666' }}>待结算(元)</Text>
                <div style={{ fontSize: 18, fontWeight: 'bold', color: '#faad14', marginTop: 4 }}>
                  ¥{accountOverview.pendingSettlement.toFixed(2)}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Card>
      
      {/* 筛选工具栏 */}
      <div style={{ 
        padding: '8px 12px', 
        background: '#fff', 
        margin: '0 12px 12px',
        borderRadius: 8,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <Search
            placeholder="搜索单号/来源/对方/描述"
            allowClear
            onSearch={handleSearch}
            style={{ width: '70%' }}
            size="middle"
          />
          <div>
            <Button 
              type="text" 
              icon={<CalendarOutlined />} 
              onClick={() => setDatePickerVisible(!datePickerVisible)}
              style={{ marginRight: 8 }}
            />
            <Button 
              type="text" 
              icon={<FilterOutlined />} 
              onClick={() => setFilterDrawerVisible(true)}
              style={{ 
                color: statusFilter.length > 0 || splitStatusFilter.length > 0 || incomeTypeFilter.length > 0 ? '#529C8A' : ''
              }}
            />
          </div>
        </div>
        
        {datePickerVisible && (
          <div style={{ marginBottom: 12 }}>
            <RangePicker 
              style={{ width: '100%' }} 
              locale={locale}
              onChange={handleDateChange}
              allowClear
              placeholder={['开始日期', '结束日期']}
            />
          </div>
        )}
        
        {/* 显示已选筛选条件 */}
        {(statusFilter.length > 0 || splitStatusFilter.length > 0 || incomeTypeFilter.length > 0) && (
          <div style={{ marginTop: 8 }}>
            <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>已选筛选条件:</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {incomeTypeFilter.map(type => {
                const typeInfo = getTransactionTypeInfo(type);
                return (
                  <Tag 
                    key={`type-${type}`} 
                    color={typeInfo.color}
                    closable
                    onClose={() => setIncomeTypeFilter(incomeTypeFilter.filter(t => t !== type))}
                  >
                    {typeInfo.text}
                  </Tag>
                );
              })}
              
              {statusFilter.map(status => {
                const statusInfo = getTransactionStatusInfo(status);
                return (
                  <Tag 
                    key={`status-${status}`} 
                    color={statusInfo.color}
                    closable
                    onClose={() => setStatusFilter(statusFilter.filter(s => s !== status))}
                  >
                    {statusInfo.text}
                  </Tag>
                );
              })}
              
              {splitStatusFilter.map(splitStatus => {
                let color = 'default';
                switch(splitStatus) {
                  case '已分账': color = 'purple'; break;
                  case '未分账': color = 'gold'; break;
                  case '不可分账': color = 'default'; break;
                  default: color = 'default';
                }
                
                return (
                  <Tag 
                    key={`splitStatus-${splitStatus}`} 
                    color={color}
                    closable
                    onClose={() => setSplitStatusFilter(splitStatusFilter.filter(s => s !== splitStatus))}
                  >
                    {splitStatus}
                  </Tag>
                );
              })}
            </div>
          </div>
        )}
      </div>
      
      {/* 类型筛选条 */}
      <div style={{ margin: '0 12px 12px' }}>
        <Radio.Group 
          value={typeFilter} 
          onChange={handleTypeChange}
          buttonStyle="solid"
          style={{ width: '100%', display: 'flex' }}
        >
          <Radio.Button value="all" style={{ flex: 1, textAlign: 'center', borderRadius: '4px 0 0 4px' }}>全部</Radio.Button>
          <Radio.Button value="income" style={{ flex: 1, textAlign: 'center', borderRadius: 0 }}>收入</Radio.Button>
          <Radio.Button value="expense" style={{ flex: 1, textAlign: 'center', borderRadius: 0 }}>支出</Radio.Button>
          <Radio.Button value="withdraw" style={{ flex: 1, textAlign: 'center', borderRadius: '0 4px 4px 0' }}>提现</Radio.Button>
        </Radio.Group>
      </div>
      
      {/* 交易明细列表 */}
      <div style={{ margin: '0 12px 12px' }}>
        {filteredTransactions.length > 0 ? (
          <List
            itemLayout="horizontal"
            dataSource={filteredTransactions}
            renderItem={item => {
              const typeInfo = getTransactionTypeInfo(item.type);
              const statusInfo = getTransactionStatusInfo(item.status);
              
              // 定义是否可以分账的条件
              const canSplit = item.type === 'commission' && 
                              item.splitStatus === '未分账' &&
                              (item.status === 'settled' || item.status === 'completed');
              
              // 定义是否显示分账状态 - 提现类型和分账收入类型不显示
              const showSplitStatus = item.type !== 'withdraw' && 
                                     item.type !== 'split_income' && 
                                     item.splitStatus;
              
              return (
                <Card 
                  style={{ marginBottom: 12, borderRadius: 8 }} 
                  bodyStyle={{ padding: 12 }}
                  onClick={() => handleViewDetail(item)}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                        <span style={{ 
                          marginRight: 8, 
                          fontSize: 16,
                          display: 'inline-block',
                          width: 24,
                          height: 24,
                          lineHeight: '24px',
                          textAlign: 'center',
                          borderRadius: 4,
                          backgroundColor: typeInfo.color === 'green' ? '#f6ffed' :
                                          typeInfo.color === 'blue' ? '#e6f7ff' :
                                          typeInfo.color === 'orange' ? '#fff7e6' :
                                          typeInfo.color === 'red' ? '#fff1f0' :
                                          typeInfo.color === 'purple' ? '#f9f0ff' : '#f5f5f5',
                          border: `1px solid ${
                            typeInfo.color === 'green' ? '#b7eb8f' :
                            typeInfo.color === 'blue' ? '#91d5ff' :
                            typeInfo.color === 'orange' ? '#ffd591' :
                            typeInfo.color === 'red' ? '#ffa39e' :
                            typeInfo.color === 'purple' ? '#d3adf7' : '#d9d9d9'
                          }`
                        }}>
                          {typeInfo.icon}
                        </span>
                        <Text strong>{item.description}</Text>
                      </div>
                      <div style={{ fontSize: 13, color: '#666' }}>
                        <Space>
                          <span>{item.date}</span>
                          {item.type === 'withdraw' ? (
                            <span>提现单号: {item.orderNo}</span>
                          ) : (
                            <span>订单号: {item.orderNo}</span>
                          )}
                        </Space>
                      </div>
                      <div style={{ marginTop: 4 }}>
                        <Space size={4}>
                          <Tag color={statusInfo.color} style={{ margin: 0 }}>{statusInfo.text}</Tag>
                          
                          {/* 只对非提现类型显示分账状态标签 */}
                          {showSplitStatus && (
                            <Tag
                              color={item.splitStatus === '已分账' ? 'purple' : 
                                     item.splitStatus === '分账收入' ? 'geekblue' : 
                                     item.splitStatus === '不可分账' ? 'default' : 'gold'}
                            >
                              {item.splitStatus}
                            </Tag>
                          )}
                        </Space>
                      </div>
                    </div>
                    <div style={{ 
                      display: 'flex', 
                      flexDirection: 'column',
                      alignItems: 'flex-end', 
                      justifyContent: 'center'
                    }}>
                      <Text 
                        strong 
                        style={{ 
                          fontSize: 18, 
                          color: item.amount >= 0 ? '#52c41a' : '#f5222d' 
                        }}
                      >
                        {item.amount >= 0 ? '+' : ''}{item.amount.toFixed(2)}
                      </Text>
                      
                      {/* 显示分账信息 */}
                      {item.splitInfo && (
                        <Text type="secondary" style={{ fontSize: 12 }}>
                          已分账: {item.splitInfo.splitAmount.toFixed(2)}
                        </Text>
                      )}
                    </div>
                  </div>
                  
                  {/* 分账按钮逻辑保持不变 */}
                  {canSplit && (
                    <div style={{ marginTop: 8, textAlign: 'right' }}>
                      <Button 
                        size="small" 
                        type="primary" 
                        ghost
                        icon={<SplitCellsOutlined />}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSplitCommission(item);
                        }}
                      >
                        分账
                      </Button>
                    </div>
                  )}
                </Card>
              );
            }}
          />
        ) : (
          <Empty 
            description="暂无符合条件的交易记录" 
            style={{ 
              background: '#fff', 
              padding: '32px 0',
              borderRadius: 8, 
              marginTop: 16 
            }}
          />
        )}
      </div>
      
      {/* 分账操作弹窗 */}
      <Modal
        title="佣金分账"
        open={splitModalVisible}
        onOk={handleSplitSubmit}
        onCancel={() => setSplitModalVisible(false)}
        okText="确认分账"
        cancelText="取消"
        okButtonProps={{ style: { backgroundColor: '#529C8A', borderColor: '#529C8A' } }}
      >
        {currentTransaction && (
          <div style={{ marginBottom: 16 }}>
            {currentTransaction.type === 'withdraw' ? (
              <p><strong>提现单号:</strong> {currentTransaction.orderNo}</p>
            ) : (
              <p><strong>订单编号:</strong> {currentTransaction.orderNo}</p>
            )}
            <p><strong>客户:</strong> {currentTransaction.customer}</p>
            <p><strong>佣金金额:</strong> ¥{currentTransaction.amount.toFixed(2)}</p>
            <p><strong>佣金状态:</strong> <Tag color={
                currentTransaction.status === 'settled' ? 'green' : 
                currentTransaction.status === 'completed' ? 'green' : 'gold'
              }>{
                currentTransaction.status === 'settled' ? '已结算' : 
                currentTransaction.status === 'completed' ? '已完成' : '处理中'
              }</Tag></p>
          </div>
        )}
        
        <Form form={splitForm} layout="vertical">
          <Form.Item
            name="splitWith"
            label="分账接收员工"
            rules={[{ required: true, message: '请选择分账接收员工' }]}
          >
            <Select placeholder="请选择员工">
              {employees.map(emp => (
                <Select.Option key={emp.id} value={emp.name}>
                  {emp.name} - {emp.position}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          
          <Form.Item
            name="splitRatio"
            label="分账比例"
            rules={[
              { required: true, message: '请输入分账比例' },
              { type: 'number', min: 0, max: 1, message: '比例必须在0-100%之间' }
            ]}
            extra={
              <div style={{ marginTop: 4 }}>
                <span>分账金额: </span>
                <span style={{ color: '#529C8A', fontWeight: 'bold' }}>
                  ¥{calculatedSplitAmount.toFixed(2)}
                </span>
                <span style={{ color: '#666', marginLeft: 8 }}>
                  (您将得到: ¥{(currentTransaction?.amount ? currentTransaction.amount - calculatedSplitAmount : 0).toFixed(2)})
                </span>
              </div>
            }
          >
            <InputNumber
              min={0}
              max={1}
              step={0.01}
              precision={2}
              style={{ width: '100%' }}
              placeholder="请输入比例，如0.3表示30%"
              value={splitRatio}
              formatter={value => value ? `${(Number(value) * 100).toFixed(0)}%` : '0%'}
              parser={(value: string | undefined) => {
                if (!value) return 0;
                const parsed = parseFloat(value.replace('%', '')) / 100;
                return isNaN(parsed) ? 0 : (parsed > 1 ? 1 : parsed < 0 ? 0 : parsed);
              }}
              onChange={(value) => {
                // 确保值为数字，且在有效范围内
                const newRatio = typeof value === 'number' ? (value > 1 ? 1 : value < 0 ? 0 : value) : 0;
                setSplitRatio(newRatio);
                if (currentTransaction) {
                  const newAmount = currentTransaction.amount * newRatio;
                  setCalculatedSplitAmount(newAmount);
                }
                // 更新表单字段值，保持同步
                splitForm.setFieldsValue({ splitRatio: newRatio });
              }}
            />
          </Form.Item>
          
          <Form.Item
            name="splitReason"
            label="分账原因"
            rules={[{ required: true, message: '请输入分账原因' }]}
          >
            <Select placeholder="请选择分账原因">
              <Select.Option value="协助服务">协助服务</Select.Option>
              <Select.Option value="客户介绍">客户介绍</Select.Option>
              <Select.Option value="合作推广">合作推广</Select.Option>
              <Select.Option value="其他">其他</Select.Option>
            </Select>
          </Form.Item>
          
          <Form.Item name="remark" label="备注说明">
            <Input.TextArea rows={2} placeholder="请输入备注说明（可选）" />
          </Form.Item>
        </Form>
        
        <div style={{ marginTop: 16, padding: 16, backgroundColor: '#f9f9f9', borderRadius: 4 }}>
          <Text type="secondary">
            提示: 确认分账后，系统将根据设置的比例将佣金分配给指定员工，此操作不可撤销。只有已结算或已完成状态的佣金才可以进行分账。
          </Text>
        </div>
      </Modal>
      
      {/* 分账规则设置弹窗 */}
      <Modal
        title="分账规则设置"
        open={splitRuleModalVisible}
        onOk={handleSplitRuleSubmit}
        onCancel={() => setSplitRuleModalVisible(false)}
        okText="保存"
        cancelText="取消"
        okButtonProps={{ style: { backgroundColor: '#529C8A', borderColor: '#529C8A' } }}
      >
        <List
          size="small"
          dataSource={splitRules}
          renderItem={item => (
            <List.Item
              actions={[
                <Switch size="small" defaultChecked={item.isActive} />
              ]}
            >
              <List.Item.Meta
                title={item.name}
                description={
                  <div>
                    <div>{item.description}</div>
                    <div style={{ color: '#529C8A' }}>分成比例: {(item.ratio * 100).toFixed(0)}%</div>
                  </div>
                }
              />
            </List.Item>
          )}
        />
        
        <Divider />
        
        <Form form={splitRuleForm} layout="vertical">
          <Form.Item
            name="name"
            label="规则名称"
            rules={[{ required: true, message: '请输入规则名称' }]}
          >
            <Input placeholder="如：管家协作分成" />
          </Form.Item>
          
          <Form.Item
            name="description"
            label="规则描述"
            rules={[{ required: true, message: '请输入规则描述' }]}
          >
            <Input.TextArea rows={2} placeholder="详细描述规则适用情况" />
          </Form.Item>
          
          <Form.Item
            name="ratio"
            label="分成比例"
            rules={[{ required: true, message: '请选择分成比例' }]}
          >
            <Select placeholder="请选择比例">
              <Select.Option value={0.1}>10%</Select.Option>
              <Select.Option value={0.2}>20%</Select.Option>
              <Select.Option value={0.3}>30%</Select.Option>
              <Select.Option value={0.4}>40%</Select.Option>
              <Select.Option value={0.5}>50%</Select.Option>
            </Select>
          </Form.Item>
          
          <Form.Item
            name="isActive"
            label="启用规则"
            valuePropName="checked"
            initialValue={true}
          >
            <Switch />
          </Form.Item>
          
          <Button 
            type="primary" 
            icon={<PlusOutlined />} 
            block
            style={{ marginTop: 16, backgroundColor: '#529C8A', borderColor: '#529C8A' }}
          >
            添加规则
          </Button>
        </Form>
      </Modal>

      {renderDetailDrawer()}
      {renderFilterDrawer()}
    </div>
  );
};

export default CommissionDetailPage; 